"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINANCIAL_RECEIPT_REQUEST_EXAMPLES = exports.cancelReceiptRequestSchema = exports.issueReceiptRequestSchema = void 0;
/**
 * Request contracts for the 2 Receipt endpoints. Field shapes mirror
 * `ReceiptApplicationService.issueReceipt`/`.cancelReceipt`
 * (`backend/src/modules/financial/application/receipt.application-service.ts`,
 * frozen, Stage 5C.3). `amount` on `issueReceipt` is required — the
 * Application Service needs it for its "Receipt → Posting" step
 * (`ReceiptManagementService` validates the payment internally but
 * doesn't return it; see that file's own header comment).
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
exports.issueReceiptRequestSchema = zod_1.z.object({
    paymentId: zod_1.z.string().uuid(),
    branchId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int().positive(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.cancelReceiptRequestSchema = zod_1.z.object({
    receiptId: zod_1.z.string().uuid(),
    expectedLockVersion: zod_1.z.number().int().positive(),
    reasonCode: zod_1.z.string().min(1),
    reasonDescription: zod_1.z.string().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.FINANCIAL_RECEIPT_REQUEST_EXAMPLES = {
    issueReceipt: {
        paymentId: '11111111-1111-1111-1111-111111111111',
        branchId: '33333333-3333-3333-3333-333333333333',
        amount: 150000,
    },
    cancelReceipt: {
        receiptId: '55555555-5555-5555-5555-555555555555',
        expectedLockVersion: 1,
        reasonCode: 'DUPLICATE',
        reasonDescription: 'Issued twice by mistake',
    },
};
//# sourceMappingURL=financial-receipt.request.js.map